"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var w=require("react"),S=require("@vfuk/core-themes"),k=require("@vfuk/core-base-props"),o=require("styled-components"),b=require("@vfuk/core-mixins");function h(e){return e&&e.__esModule?e:{default:e}}var n=h(w),i=h(o);const _=b.createMixin((e,r,t,a)=>o.css`
      @supports (display: grid) {
        display: inline-flex;
      }
      display: none;
      width: ${t}px;
      height: ${t}px;
      align-items: center;
      justify-content: center;
      @keyframes passingWay {
        0% {
          stroke-dashoffset: 115;
          stroke-dasharray: 0, 115;
          stroke-width: 0;
        }
        20% {
          stroke-width: 4;
        }
        45% {
          stroke-dashoffset: 0;
          stroke-dasharray: 115, 0;
          stroke-width: 4;
        }
        55% {
          stroke-dashoffset: 0;
          stroke-dasharray: 115, 0;
          stroke-width: 4;
        }
        80% {
          stroke-width: 4;
        }
        100% {
          stroke-dashoffset: 115;
          stroke-dasharray: 0, 115;
          stroke-width: 0;
        }
      }
      svg {
        width: ${r}px;
        height: ${t}px;
        > path {
          stroke-width: 4;
          stroke: ${a};
          animation: passingWay 3s ease infinite both;
        }
      }
    `),c=e=>{const r=n.default.createElement("svg",{width:"34",height:"44",viewBox:"0 0 34 44",fill:"none",xmlns:"http://www.w3.org/2000/svg"},n.default.createElement("path",{d:"M25.0866 15.9962C22.7495 14.7514 21.4788 14.5559 18.482 14.057C18.482 8.56832 21.9782 3.07968 21.9782 3.07968C21.9782 3.07968 16.551 4.00486 12.5013 6.57245C9.73842 8.32411 7.14499 10.9895 5.50887 13.558C2.40439 18.0002 1.84278 22.5264 2.03315 26.2641C2.24667 35.0364 9.56734 41.5797 17.5622 41.5797C25.557 41.5797 32 35.3206 32 27.2828C32 21.6166 29.359 18.3599 25.3801 16.1557",stroke:"#E60000"}));return{appearance:{primary:{color:e.color.monochrome6.default,inverse:{color:e.inverseColor.monochrome6.default}},secondary:{color:e.color.primary1.default,inverse:{color:e.inverseColor.primary1.default}}},svg:r,size:{1:{width:13,height:18},2:{width:17,height:23},3:{width:24,height:30},4:{width:28,height:36},5:{width:34,height:44}},animationStyle:_}},O=typeof i.default=="object"&&"default"in i.default?i.default.default:i.default,u=O.span(e=>{var r,t;const a=e.inverse?(r=e.loadingSpinnerTheme.appearance[e.appearance])==null?void 0:r.inverse.color:(t=e.loadingSpinnerTheme.appearance[e.appearance])==null?void 0:t.color;return o.css`
    ${e.loadingSpinnerTheme.animationStyle(e.loadingSpinnerTheme.size[e.size].width,e.loadingSpinnerTheme.size[e.size].height,a)}
  `});var j=Object.freeze({__proto__:null,LoadingSpinner:u}),x=Object.defineProperty,C=Object.defineProperties,T=Object.getOwnPropertyDescriptors,d=Object.getOwnPropertySymbols,$=Object.prototype.hasOwnProperty,z=Object.prototype.propertyIsEnumerable,p=(e,r,t)=>r in e?x(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t,L=(e,r)=>{for(var t in r||(r={}))$.call(r,t)&&p(e,t,r[t]);if(d)for(var t of d(r))z.call(r,t)&&p(e,t,r[t]);return e},P=(e,r)=>C(e,T(r));const f=({appearance:e="primary",size:r=1,inverse:t=!1,localTheme:a,id:g,dataAttributes:v,dataSelectorPrefix:m})=>{const s="LoadingSpinner",l=S.useLocalTheme(s,c,a),{svg:y}=l;return n.default.createElement(u,P(L({loadingSpinnerTheme:l,size:r,appearance:e,inverse:t,id:g},v),{"data-selector":k.getDataSelector(m),"data-component-name":s}),y)};exports.LoadingSpinner=f;exports.LoadingSpinnerStyles=j;exports.default=f;exports.loadingSpinnerTheme=c;
//# sourceMappingURL=index.cjs.map
